export function viewFourHint(state, payload) {
  return {
    ...state,
    designChapter: updateDesignChapter(state.designChapter, payload),
  };
}

function updateDesignChapter(designChapter) {
  let isHintApplied = false;
  let optionId = undefined;

  const updateInSlideTree = (slideTree) => {
    return slideTree.map((groupItem) => {
      return {
        ...groupItem,
        groupNodes: groupItem.groupNodes.map(updateGroupNode),
      };
    });
  };

  const updateGroupNode = (groupNode) => {
    if (!isHintApplied) {
      return {
        ...groupNode,
        nodeComponents: groupNode.nodeComponents.map(updateNodeComponent),
      };
    } else return groupNode;
  };

  const updateNodeComponent = (nodeComponent) => {
    if (!isHintApplied && nodeComponent.droppedId === null) {
      isHintApplied = true;
      optionId = nodeComponent.answerId[0];
      return { ...nodeComponent, droppedId: nodeComponent.answerId[0] };
    }
    return nodeComponent;
  };

  const updateDroppedOptionVisibility = (optionItem) => {
    return {
      ...optionItem,
      list: optionItem.list.map((listItem) => {
        if (listItem.id === optionId) return { ...listItem, visible: false };
        return listItem;
      }),
    };
  };

  return {
    ...designChapter,
    currentView: {
      ...designChapter.currentView,
      slideTree: updateInSlideTree(designChapter.currentView.slideTree),
      options: designChapter.currentView.options.map(
        updateDroppedOptionVisibility
      ),
      ...updateHintsLeft(designChapter.currentView.hintsLeft, isHintApplied),
      ...updateCompleteFeedbackData(designChapter.currentView),
    },
  };
}

function updateCompleteFeedbackData({ correctNodeComponents }) {
  if (correctNodeComponents != undefined)
    return { correctNodeComponents: correctNodeComponents + 1 };
  else return {};
}

function updateHintsLeft(hintsLeft, isHintApplied) {
  if (isHintApplied) return { hintsLeft: hintsLeft - 1 };
  else return {};
}
